import * as Yup from "yup";
import { useFormik, Form, Field, ErrorMessage } from 'formik';





const UseCustomFormik = (step,isNicVerified) => {



  const ValidationSchemaArray = [
    Yup.object({
      NIC:Yup.string().required("*Required")
      .test('','NIC Invalid',(val)=>{
     
         
        
      
        var inputValue = val.toUpperCase();
  
        const oneBeforeLastChar = inputValue.slice(-2, -1);

          if (inputValue.length < 10) {
            // Filter the input to allow only numbers, 'X', 'V', 'x', and 'v'
            return false;
            
          } else if (inputValue.length === 10 && (inputValue.endsWith('X') || inputValue.endsWith('V'))) {
            // If the length is 10 and ends with 'X' or 'V', update the state with the original input
            return true;
          } else if (inputValue.length < 12 && (oneBeforeLastChar !== "X" && oneBeforeLastChar !== "V")) {
            // Filter the input to allow only numbers, 'X', 'V', 'x', and 'v'
            return false;
          } else if (inputValue.length === 12 && /^\d+$/.test(inputValue)) {
            // If the length is 12 and consists of only digits, update the state with the original input
            return true;
          } 
       

 
     
   })
     
     ,
       Mobile:Yup.string().required("*Required").max(10,"Invalid Mobile Number").min(10,"Invalid Mobile Number")
       //.test('','mobile number does not match',(val)=>{
      //   if (data) {
      //     const exist = data.find((item) => {
      //       return item.nic === formik.values.NIC;
      //     });
     
        
          
      //     if(exist){
      //       if (exist.mobile==val){
      //        return true;
     
      //       }
      //       else{
      //        return false;
      //       }
     
      //       }
      //   }
      
   
       
      // }),
     

    }),

  ]
  const formik = useFormik({
    initialValues: {
      NIC:sessionStorage.getItem('TempNIC')||"",
      Mobile:sessionStorage.getItem('TempMobile')||"",
     
   


    },
    validationSchema: ValidationSchemaArray[(step - 1)]
    ,

  });


  return formik;

}


export default UseCustomFormik;